export const getSiblingItemsStockStatus = (stockStatusesData) => {
    const stockStatuses = {};
    stockStatusesData.products.items.forEach((item) => {
        stockStatuses[item.sku] = item.stock_status;
    });
    return stockStatuses;
};
//# sourceMappingURL=getSiblingItemsStockStatus.js.map